import * as React from 'react';
import * as R from 'ramda';
var isObject = function (obj) { return Object.prototype.toString.call(obj) === '[object Object]'; };
var isArray = function (obj) { return Object.prototype.toString.call(obj) === '[object Array]'; };
function mapOpenGraphData(obj) {
    return R.pipe(R.toPairs, R.chain(function (_a) {
        var k = _a[0], v = _a[1];
        if (isObject(v)) {
            return R.map(function (_a) {
                var k1 = _a[0], v1 = _a[1];
                return [
                    k + ":" + k1,
                    v1 ? v1.toString() : undefined,
                ];
            }, mapOpenGraphData(v));
        }
        if (isArray(v)) {
            return R.chain(function (v1) { return R.map(function (_a) {
                var k2 = _a[0], v2 = _a[1];
                return [k + ":" + k2, v2];
            }, mapOpenGraphData(v1)); }, v);
        }
        return [[k, v ? v.toString() : undefined]];
    }))(obj);
}
export function renderOpenGraph(data) {
    if (data === undefined) {
        return undefined;
    }
    return R.pipe(mapOpenGraphData, R.chain(function (_a) {
        var prop = _a[0], cont = _a[1];
        return cont !== undefined
            ? [React.createElement("meta", { key: prop, property: prop, content: cont })]
            : [];
    }))(data);
}
